<template>
  <div class="SIDENAV">
    <router-link
        :to="{ name: 'pro-desk-reporting::report' }"
        active-class="LINK-ACTIVE"
        class="SIDENAV-ITEM d-flex jc-between ai-center w-100 p-2 p-3:t">
      <span class="h5 c-white">Pro In-Stock</span>
      <vk-icon class="c-depot" name="chevronright" size="16"/>
    </router-link>
    <router-link
        :to="{ name: 'pro-desk-reporting::testimonials' }"
        active-class="LINK-ACTIVE"
        class="SIDENAV-ITEM d-flex jc-between ai-center w-100 p-2 p-3:t">
      <span class="h5 c-white">What our Pros Say</span>
      <vk-icon class="c-depot" name="chevronright" size="16"/>
    </router-link>
    <router-link
        :to="{ name: 'pro-desk-reporting::resources' }"
        active-class="LINK-ACTIVE"
        class="SIDENAV-ITEM d-flex jc-between ai-center w-100 p-2 p-3:t">
      <span class="h5 c-white">Resources</span>
      <vk-icon class="c-depot" name="chevronright" size="16"/>
    </router-link>
    <router-link
        :to="{ name: 'pro-desk-reporting::requirements' }"
        active-class="LINK-ACTIVE"
        class="SIDENAV-ITEM d-flex jc-between ai-center w-100 p-2 p-3:t">
      <span class="h5 c-white">Pro Referral Requirements</span>
      <vk-icon class="c-depot" name="chevronright" size="16"/>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'pro-desk-reporting-navigation',
  methods: {
    goToSalesforce () {
      window.location.href = `${this.$runtimeConstants.SALESFORCE_BECOME_A_PRO}&STOREID=${this.$route.params.storeId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.SIDENAV {
  margin-top: $unit * 9;
  background-color: $color-gray90;
}

.SIDENAV-ITEM {
  border-left: 6px solid transparent;
  border-bottom: 1px solid $color-gray80;
  cursor: pointer;

  &.LINK-ACTIVE {
    border-left: 6px solid $color-depot;
    background-color: $color-gray80;
  }
}
</style>
